<template>
    <div v-bind:class="{'effect-moveIn' : true, 'effect-moveOut' : false }" class="basket-item-container col-12 couponcode">
        <div class="row">
            <div class="col-12 couponcode-caption">
                <translate item="addCouponCode" fallback="VOEG EEN KORTINGSCODE TOE"></translate>
            </div>
        </div>
        <div class="row row-couponcode-input">
            <div class="col couponcode-input-wrapper">
                <input type="text" class="form-control" v-model="couponCodeInput" v-on:keyup.enter="applyCouponCode" :placeholder="placeholder" />
            </div>
            <div class="text-right col-auto col-btn">
                <span class="btn btn-link btn-success d-inline-block d-sm-none" v-on:click="applyCouponCode"><i class="icon-apply"></i></span>
                <span class="btn btn-link btn-success d-none d-sm-inline-block" v-on:click="applyCouponCode"><translate item="applyCouponCode" fallback="TOEPASSEN" /></span>
            </div>
        </div>
        <div class="row row-couponcode-error" v-if="errorMessage">
            <div class="col-12">
                <span class="text-danger">{{ errorMessage }}</span>
            </div>
        </div>
        <div class="row row-couponcode-tags" v-if="cart.model.appliedCouponCodes && cart.model.appliedCouponCodes.length > 0">
            <div class="col-12">
                <div><translate item="appliedCouponCodes" fallback="Toegevoegde couponcodes" /></div>
                <span class="couponcode-tag" v-for="code in cart.model.appliedCouponCodes" :key="code">
                    <span class="couponcode-tag-label">{{ code }}</span>
                    <span class="couponcode-tag-remove" v-on:click="removeCouponCode(code)"><i class="icon-trash"></i></span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>

    import shoppingCartService from '../Services/ShopingCartService';
    import translate from './translate';

    export default {

        props: { "cart": Object },
        components: { translate },
        data: function () {
            return {
                couponCodeInput: '',
                errorMessage: ''
            };
        },
        computed: {
            placeholder: function () {
                return 'Kortingscode';
            }
        },
        methods: {
            applyCouponCode: function () {
                var code = this.couponCodeInput.trim();
                if (!code) return;

                // Check voor duplicaat
                if (this.cart.model.appliedCouponCodes &&
                    this.cart.model.appliedCouponCodes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
                    this.errorMessage = 'Deze kortingscode is al toegevoegd.';
                    return;
                }

                this.errorMessage = '';
                var self = this;
                shoppingCartService.applyCouponCode(code, function (result) {
                    if (result && !result.success && result.error) {
                        self.errorMessage = result.error;
                    } else {
                        self.couponCodeInput = '';
                    }
                });
            },
            removeCouponCode: function (code) {
                this.errorMessage = '';
                shoppingCartService.removeCouponCode(code);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// Vue/Src/Components/amz-cart-couponcode.vue